export function canApplySettingsProgressRefresh({
  requestGeneration,
  currentGeneration,
  routeName,
  routeSection,
  modalOpen,
  documentHidden
}) {
  return requestGeneration === currentGeneration
    && routeName === 'settings'
    && ['mailboxes', 'integrations'].includes(routeSection)
    && !modalOpen
    && !documentHidden;
}
